import { render, staticRenderFns } from "./contractDOT.vue?vue&type=template&id=b3a72908&"
import script from "./contractDOT.vue?vue&type=script&lang=js&"
export * from "./contractDOT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports